import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import { Route, Routes, useNavigate } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import Login from "./pages/Authentication/login/Login";
import MainLayout from "./pages/MainLayout";
import Register from "./pages/Authentication/register/Register";
import AuthLayout from "./pages/Authentication/layout/AuthLayout";
import Watchlist from "./pages/watchlist/Watchlist";
import Standouts from "./pages/standouts/Standouts";
import Profile from "./pages/profile/profile";
import "./assets/font/Roboto/Roboto-Bold.ttf";
import "./assets/font/Roboto/Roboto-Medium.ttf";
import "bootstrap/dist/css/bootstrap.min.css";
import { ThemeContext } from "./context/theme-context";
import { useEffect, useRef, useState } from "react";
import MarketSummary from "./pages/market/marketSummary/marketSummary";
import DividendExpectations from "./pages/dividends/dividendExpectations/DividendExpectations";
import DividendFiltering from "./pages/dividends/dividendFiltering/DividendFiltering";
import IndexAnalysis from "./pages/market/indexAnalysis/indexAnalysis";
import StockIndexEffect from "./pages/market/stockIndexEffect/stockIndexEffect";
import DividendCalculator from "./pages/dividends/dividendCalculator/DividendCalculator";
import GlobalIndices from "./pages/market/globalIndices/globalIndices";
import News from "./pages/news/news";
import DividendCalendar from "./pages/dividends/dividendCalendar/DividendCalendar";
import TechnicalAnalysis from "./pages/technicalAnalysis/technicalAnalysis";
// import TransactionAnalysis from './pages/transactionAnalysis/TransactionAnalysis'; //FAZ 2 Ertelendi
import StockFiltering from "./pages/stockFiltering/stockFiltering";
import SymbolPersonalSort from "./pages/symbolPersonalSort/symbolPersonalSort";
import StockAnalysisReport from "./pages/stockAnalysis/stockAnalysisReport/StockAnalysisReport";
import StockAnalysisNews from "./pages/stockAnalysis/stockAnalysisNews/StockAnalysisNews";
import StockAnalysisAffiliatesPartnerships from "./pages/stockAnalysis/stockAnalysisAffiliatesPartnerships/StockAnalysisAffiliatesPartnerships";
import StockAnalysisDividend from "./pages/stockAnalysis/dividend/Dividend";
import StockAnalysisCompare from "./pages/stockAnalysis/stockAnalysisCompare/StockAnalysisCompare";
import FinancialStatement from "./pages/stockAnalysis/financialStatement/FinancialStatement";
import StockAnalysisIndicators from "./pages/stockAnalysis/indicators/indicators";
import Ratio from "./pages/stockAnalysis/ratios/Ratio";
import Summary from "./pages/stockAnalysis/summary/Summary";
import Main from "./pages/stockAnalysis/main";
import * as wjcCore from "@grapecity/wijmo";
import * as am4core from "@amcharts/amcharts4/core";
import * as am5 from "@amcharts/amcharts5";
import Screener from "./pages/technicalAnalysis/screener/Screener";
import { useDispatch } from "react-redux";
import { logout } from "./stores/auth";
import Calculator from "./pages/dividends/calculator/Calculator";
import ResetPasswordFromMail from "./pages/Authentication/resetPassword/ResetPasswordFromMail";
import "./gtm";
import { ToastProvider } from "./context/toast-context";
import PortfolioMain from "./pages/portfolio/PortfolioMain";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useNoIndexForTestDomain } from "./helpers/useNoIndexForTestDomain";
import { HitTrackingProvider } from "./context/hit-tracking-context";
function App() {
  useNoIndexForTestDomain();
  const isBrowserDefaulDark = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getDefaultTheme = () => {
    const localStorageTheme = localStorage.getItem("default-theme");

    let browserDefault = "dark";

    if (process.env.NODE_ENV === "development") {
      //TODO:Ürünün ilk çıktığı zaman geri aç
      //const browserDefault = isBrowserDefaulDark() ? 'dark' : 'light';
      browserDefault = "light";
    }

    return localStorageTheme || browserDefault;
  };

  const [theme, setTheme] = useState(getDefaultTheme());
  const body = document.body;

  wjcCore.setLicenseKey(

    "hisselab.rasyonet.com|hisselab.equityrt.com,182512168472953#B0YMdIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPRxUbIBXQ0FTTW5EUtlFSxx6TWpEavJGToNWY8AHRiFjU5YUaGlVaIdmQ0hUVON7d9sEeZ5EM0B7K0ZXZFRHUmJUMJJ7dGNkb8ZjSShlRr2Ge9ZXM44WNZlDb9k4a8pVTah7aO9GRFdWYNNDZUxUUhFzTzNDSNFjc0tGMWRFePdES9F7UONEOGBVONlUY52SbkJHephzKnp6LSFWWwgXbDdXQUVkSzFTdvpkdJZmdJN7L7dzMNhzVEJkWhhVS0RnWN3ENwUHOHZUdRdTdS3kRGJkQ6IEcWNUWph4M5RHcwkEcPp6QLZ6dnl5bx9kQzhVYxo5QvMWVmZkQz3CNl9mTGJDaOV6VkR6MvZ4QSl4Mu9kNplkSuBTUnxEMPl6Sx5USPxWSrokaI9UdPRVbWJmUjhldyIHVDh5UK56Z4F6buFUS5UWVVRXaxJ5MVFEaCJkYLR5UuZWRiojITJCLikjRDFUMDRTMiojIIJCL8YDMxMjNwETO0IicfJye#4Xfd5nIJBjMSJiOiMkIsIibvl6cuVGd8VEIgQXZlh6U8VGbGBybtpWaXJiOi8kI1xSfiUTSOFlI0IyQiwiIu3Waz9WZ4hXRgAicldXZpZFdy3GclJFIv5mapdlI0IiTisHL3JyS7gDSiojIDJCLi86bpNnblRHeFBCI73mUpRHb55EIv5mapdlI0IiTisHL3JCNGZDRiojIDJCLi86bpNnblRHeFBCIQFETPBCIv5mapdlI0IiTisHL3JyMDBjQiojIDJCLiUmcvNEIv5mapdlI0IiTisHL3JSV8cTQiojIDJCLi86bpNnblRHeFBCI4JXYoNEbhl6YuFmbpZEIv5mapdlI0IiTis7W0ICZyBlIsICN5QTMyEDI8EjNwYjMwIjI0ICdyNkIsISbvNmL4JXe4lWdxVmLiFGblN7cphGLt36YuQXZu3WezFmcuIWYsV6czlGaiojIz5GRiwiISFUWBNVSHxUSCBCVF94TZNVQSJiOiEmTDJCLiMTN9IzN4gjNxITM5IDOxIiOiQWSiwSfdtlOicGbmJCLiIZdJI"

  );

  useEffect(() => {
    if (
      localStorage.getItem("token") === null &&
      !window.location.pathname.startsWith("/resetpassword")
    ) {
      dispatch(logout());
      navigate("/auth/login");
    }

    if (localStorage.getItem("expireDate")) {
      const expireDate = new Date(localStorage.getItem("expireDate"));
      const now = new Date();
      if (expireDate < now) {
        dispatch(logout());
        navigate("/auth/login");
      }
    }
  }, []);

  useEffect(() => {
    am4core.addLicense("CH241247396"); // AmCharts 4 lisans anahtarı ekleniyor
    am4core.options.commercialLicense = true;
    am5.addLicense("AM5C-241247396"); // AmCharts 5 lisans anahtarı ekleniyor
    localStorage.setItem("default-theme", theme);
    setTheme(getDefaultTheme());
    body.classList.remove("theme-light", "theme-dark");
    body.classList.add(`theme-${theme}`);
  }, [theme]);

  return (
    <>
      <ToastProvider>
        <ThemeContext.Provider value={{ theme, setTheme }}>
          <HitTrackingProvider>
            <div className={`theme-${theme}`}>
              <div className="App root fill-window">
                <Routes>
                <Route
                  path="/"
                  element={
                    <PrivateRoute>
                      <MainLayout />
                    </PrivateRoute>
                  }
                >
                  <Route
                    index={true}
                    element={
                      <PrivateRoute>
                        <Login />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="watchlist"
                    element={
                      <PrivateRoute>
                        <Watchlist />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="standouts"
                    element={
                      <PrivateRoute>
                        <Standouts />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="profile"
                    element={
                      <PrivateRoute>
                        <Profile />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="marketSummary"
                    element={
                      <PrivateRoute>
                        <MarketSummary />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="dividends/dividendExpectations"
                    element={
                      <PrivateRoute>
                        <DividendExpectations />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="dividends/dividendFiltering"
                    element={
                      <PrivateRoute>
                        <DividendFiltering />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="dividends/dividendCalculator"
                    element={
                      <PrivateRoute>
                        <DividendCalculator />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="dividends/dividendCalendar"
                    element={
                      <PrivateRoute>
                        <DividendCalendar />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="dividends/Calculator"
                    element={
                      <PrivateRoute>
                        <Calculator />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="indexAnalysis"
                    element={
                      <PrivateRoute>
                        <IndexAnalysis />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="stockIndexEffect"
                    element={
                      <PrivateRoute>
                        <StockIndexEffect />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="globalIndices"
                    element={
                      <PrivateRoute>
                        <GlobalIndices />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="news"
                    element={
                      <PrivateRoute>
                        <News constutientEntityId={'ANY'} entityIds={[]} showLiveTicker={false} mainNews={true} />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="technicalAnalysis/:code"
                    element={
                      <PrivateRoute>
                        <TechnicalAnalysis />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="technicalAnalysis"
                    element={
                      <PrivateRoute>
                        <TechnicalAnalysis />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="screener"
                    element={
                      <PrivateRoute>
                        <Screener />
                      </PrivateRoute>
                    }
                  />
                  {/* <Route path='transactionAnalysis' element={<PrivateRoute><TransactionAnalysis /></PrivateRoute>} /> //FAZ 2 Ertelendi */}
                  <Route
                    path="stockFiltering"
                    element={
                      <PrivateRoute>
                        <StockFiltering />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="personalSorting"
                    element={
                      <PrivateRoute>
                        <SymbolPersonalSort />
                      </PrivateRoute>
                    }
                  />

                  <Route
                    path="Portfolio"
                    element={<PortfolioMain />}
                  />
                  {/* <Route path='stockAnalysis/Report' element={<PrivateRoute><StockAnalysisReport /></PrivateRoute>} /> */}
                  {/* <Route path='stockAnalysis/News' element={<PrivateRoute><StockAnalysisNews /></PrivateRoute>} /> */}
                  {/* <Route path='stockAnalysis/AffiliatesPartnerships' element={<PrivateRoute><StockAnalysisAffiliatesPartnerships /></PrivateRoute>} /> */}
                  {/* <Route path='stockAnalysis/Dividend' element={<PrivateRoute><StockAnalysisDividend /></PrivateRoute>} /> */}
                  {/* <Route path='stockAnalysis/Compare' element={<PrivateRoute><StockAnalysisCompare /></PrivateRoute>} /> */}
                  {/* <Route path='stockAnalysis/FinancialStatement' element={<PrivateRoute><FinancialStatement /></PrivateRoute>} /> */}
                  {/* <Route path='stockAnalysis/StockAnalysisIndicators' element={<PrivateRoute><StockAnalysisIndicators /></PrivateRoute>} /> */}
                  {/* <Route path='stockAnalysis/Summary' element={<PrivateRoute><Summary /></PrivateRoute>} /> */}
                  {/* <Route path='stockAnalysis' element={<PrivateRoute><StockAnalysisIndex /></PrivateRoute>} /> */}
                  {/* <Route path='stockAnalysis' element={<PrivateRoute>< Main /></PrivateRoute>} /> */}
                  <Route
                    path="/stockAnalysis"
                    element={
                      <PrivateRoute>
                        <Main />
                      </PrivateRoute>
                    }
                  >
                    <Route
                      path="summary/:id"
                      element={
                        <PrivateRoute>
                          <Summary />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="indicators/:id"
                      element={
                        <PrivateRoute>
                          <StockAnalysisIndicators />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="financialStatement/:id"
                      element={
                        <PrivateRoute>
                          <FinancialStatement />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="ratio/:id"
                      element={
                        <PrivateRoute>
                          <Ratio />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="compare/:id"
                      element={
                        <PrivateRoute>
                          <StockAnalysisCompare />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="dividend/:id"
                      element={
                        <PrivateRoute>
                          <StockAnalysisDividend />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="affiliatesPartnerships/:id"
                      element={
                        <PrivateRoute>
                          <StockAnalysisAffiliatesPartnerships />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="news/:id"
                      element={
                        <PrivateRoute>
                          <StockAnalysisNews />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="report/:id"
                      element={
                        <PrivateRoute>
                          <StockAnalysisReport />
                        </PrivateRoute>
                      }
                    />
                  </Route>
                </Route>

                <Route
                  path="resetpassword"
                  element={<ResetPasswordFromMail />}
                />


                <Route path="/auth" element={<AuthLayout />}>
                  <Route path="login" element={<Login />} />
                  <Route path="register" element={<Register />} />
                </Route>
                <Route path="*" element={<h1>Not Found</h1>} />
                </Routes>
              </div>
            </div>
          </HitTrackingProvider>
        </ThemeContext.Provider>
      </ToastProvider>
    </>
  );
}

export default App;
